import React from 'react';
import { Link } from 'gatsby'

const BonsPlansJeunesBreadcrumb = ({ SingleTitle }) => {
	// Validation des props
	if (SingleTitle && typeof SingleTitle !== 'string') {
		return (
			<div 
				className="d-none d-lg-block d-md-block d-sm-block order-bottom py-2"
				role="alert"
				aria-live="polite"
				aria-describedby="breadcrumb-error-description"
			>
				<div 
					id="breadcrumb-error-description" 
					className="visually-hidden"
					data-testid="breadcrumb-error-description"
				>
					Erreur d'affichage du fil d'Ariane
				</div>
				<p 
					className="text-danger"
					data-testid="breadcrumb-error-message"
				>
					Erreur d'affichage du fil d'Ariane
				</p>
			</div>
		)
	}

	const breadcrumbId = 'bons-plans-jeunes-breadcrumb'
	const currentPageId = 'current-page-breadcrumb'

	return (
		<div className="d-none d-lg-block d-md-block d-sm-block order-bottom py-2">
			<div className="container">
				<nav 
					className="" 
					aria-label="Fil d'Ariane"
					role="navigation"
					aria-labelledby={breadcrumbId}
				>
					<div id={breadcrumbId} className="visually-hidden">
						Navigation dans le site pour accéder aux bons plans jeunes
					</div>
					<ol className="breadcrumb" role="list">
						<li className="breadcrumb-item" role="listitem">
							<Link 
								className="text-dark" 
								to="/"
								aria-label="Retour à l'accueil du site"
							>
								Accueil
							</Link>
						</li>
						<li className="breadcrumb-item" role="listitem">
							<Link 
								className="text-dark" 
								to="/services-infos-pratiques/"
								aria-label="Accéder aux services et infos pratiques"
							>
								Services & infos pratiques
							</Link>
						</li> 
						<li className="breadcrumb-item" role="listitem">
							<Link 
								className="text-dark" 
								to="/services-infos-pratiques/jeunesse/"
								aria-label="Accéder à la section jeunesse"
							>
								Jeunesse
							</Link>
						</li> 
						{ SingleTitle ? (
							<li className="text-secondary breadcrumb-item" role="listitem">
								<Link 
									className="text-dark" 
									to="/services-infos-pratiques/jeunesse/bons-plans-pour-les-jeunes/"
									aria-label="Accéder à la liste des bons plans jeunes"
								>
									Bons plans jeunes
								</Link>
							</li>
						) : (
							<li 
								className="text-secondary breadcrumb-item" 
								role="listitem"
								aria-current="page"
								id={currentPageId}
							>
								<span aria-label="Page actuelle : Bons plans jeunes">
									Bons plans jeunes
								</span>
							</li>
						)}
						{ SingleTitle && (
							<li 
								className="text-secondary breadcrumb-item" 
								role="listitem"
								aria-current="page"
								id={currentPageId}
							>
								<span aria-label={`Page actuelle : ${SingleTitle}`}>
									{SingleTitle}
								</span>
							</li>
						)}
					</ol>
				</nav>
			</div>
		</div>
	)
}

export default BonsPlansJeunesBreadcrumb;